// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__230fR","select":"Header_select__2ZwCg","clinic":"Header_clinic__2t4kg"};